export default __webpack_public_path__ + "8c17a6ab5edbdcc07ec58baa3178a2a5.png";